<input
  [attr.name]="name"
  type="time"
  class="time-input-element"
  [ngClass]="{'hide-arrow': isSafari()}"
  [formControl]="time"
  aria-label="Time"
  (input)="_handleTimeInput()"
/>
